import { render, staticRenderFns } from "./CraftOrder.vue?vue&type=template&id=4bcd1b8b&scoped=true&"
import script from "./CraftOrder.vue?vue&type=script&lang=ts&"
export * from "./CraftOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd1b8b",
  null
  
)

export default component.exports